import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// BANK ACCOUNTS VERIFICATION
// Legacy: /AccountsApproval/VerifyBankAccounts (+ Grid / View partials)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — bank accounts pending at this role's workflow level (row carries MOID).
export const getVerificationBankAccounts = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetVerificationBankAccounts`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of one bank account.
export const getVerificationBankById = async (bankId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetVerificationBankbyid`, { params: { Bankid: bankId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Return / Reject (spApproveBankAccount — success literal "Submited").
export const approveBankAccounts = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/ApproveBankAccounts`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Resubmit a returned account with an updated location / minimum balance
// (SpUpdateReturnedbankAcc — success literal "Submitted").
export const updateReturnedBankAccount = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/UpdateReturnedbankAcc`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
